import { createContext } from 'preact';

const WidgetConfigContext = createContext({});
export default WidgetConfigContext;
